export const PHOTOREAL_PRODUCTS_EXCLUDED = 1;
export const PHOTOREAL_PRODUCTS_ONLY = 2;
export const PHOTOREAL_PRODUCTS_INCLUDED = 3;
